import React, { useState } from 'react';
import { Box, Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Cancel, Done } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';
import useError from 'components/ErrorProvider/useError';
import { IMessageDialogProps } from './interfaces';
import './styles.scss';

const MessageDialog: React.FC<IMessageDialogProps> = ({
  open,
  isSuccess,
  successText,
  errorText,
  onClose,
  onContinue,
  onConfirm,
  renderContent,
  title,
}) => {
  const [loading, setLoading] = useState(false);

  // Global notification
  const { addError } = useError();

  const confirm = (): void => {
    if (onConfirm) {
      onConfirm()
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(true);
          addError('Error occured');
        });
    }
  };

  return (
    <Dialog open={open} onClose={onClose} className="global-message-dialog" maxWidth={isMobile ? 'sm' : 'lg'}>
      <div className="global-message-dialog__wrapper">
        {title && (
          <DialogTitle>
            <b>{title ? title : 'Сообщение'}</b>
          </DialogTitle>
        )}
        <DialogContent>
          {successText && isSuccess && (
            <Box>
              <p>
                <div className="global-message-dialog__svg-icon --success">
                  <svg width="38" height="29" viewBox="0 0 38 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.875 22.7088L4.21212 15.0458C3.79921 14.6329 3.23919 14.401 2.65524 14.401C2.0713 14.401 1.51128 14.6329 1.09837 15.0458C0.685461 15.4587 0.453491 16.0188 0.453491 16.6027C0.453491 16.8919 0.510442 17.1782 0.62109 17.4453C0.731739 17.7124 0.893918 17.9551 1.09837 18.1596L10.3292 27.3904C11.1905 28.2517 12.5817 28.2517 13.443 27.3904L36.8071 4.02625C37.22 3.61334 37.452 3.05332 37.452 2.46938C37.452 1.88544 37.22 1.32541 36.8071 0.912503C36.3942 0.499594 35.8342 0.267624 35.2502 0.267624C34.6663 0.267624 34.1063 0.499594 33.6934 0.912503L11.875 22.7088Z"
                      fill="#A5DC86"
                    />
                  </svg>
                </div>
                {successText}
              </p>
            </Box>
          )}
          {errorText && !isSuccess && (
            <Box>
              <p>
                <div className="global-message-dialog__svg-icon --error">
                  <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M18.0134 14.5L27.8473 4.66605C28.3141 4.20016 28.5766 3.56794 28.5772 2.90848C28.5778 2.24903 28.3163 1.61635 27.8505 1.14963C27.3846 0.682908 26.7523 0.420381 26.0929 0.419799C25.4334 0.419216 24.8007 0.680626 24.334 1.14652L14.5 10.9805L4.66605 1.14652C4.19933 0.679803 3.56633 0.417603 2.90629 0.417603C2.24625 0.417603 1.61324 0.679803 1.14652 1.14652C0.679803 1.61324 0.417603 2.24625 0.417603 2.90629C0.417603 3.56633 0.679803 4.19933 1.14652 4.66605L10.9805 14.5L1.14652 24.334C0.679803 24.8007 0.417603 25.4337 0.417603 26.0938C0.417603 26.7538 0.679803 27.3868 1.14652 27.8536C1.61324 28.3203 2.24625 28.5825 2.90629 28.5825C3.56633 28.5825 4.19933 28.3203 4.66605 27.8536L14.5 18.0196L24.334 27.8536C24.8007 28.3203 25.4338 28.5825 26.0938 28.5825C26.7538 28.5825 27.3868 28.3203 27.8536 27.8536C28.3203 27.3868 28.5825 26.7538 28.5825 26.0938C28.5825 25.4337 28.3203 24.8007 27.8536 24.334L18.0134 14.5Z"
                      fill="#E74C3C"
                    />
                  </svg>
                </div>
                {errorText}
              </p>
            </Box>
          )}
          {renderContent && <Box>{renderContent}</Box>}
        </DialogContent>

        <DialogActions>
          <ButtonGroup className="global-message-dialog__button-group">
            {onConfirm && (
              <Button startIcon={<Done />} onClick={confirm} disabled={loading} style={{ color: 'white' }}>
                ОК
              </Button>
            )}
            {onClose && (
              <Button startIcon={<Cancel />} onClick={onClose} disabled={loading} style={{ color: 'white' }}>
                Закрыть
              </Button>
            )}
            {onContinue && (
              <Button
                variant="contained"
                onClick={onContinue}
                color="primary"
                disabled={loading}
                style={{ color: 'white' }}
              >
                Продолжить
              </Button>
            )}
          </ButtonGroup>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default MessageDialog;
